// extracted by mini-css-extract-plugin
module.exports = {"shareLinks":"ShareLinks_shareLinks__YSGOz","copyButton":"ShareLinks_copyButton__oIvEI"};